import React from 'react';

const DifferenceSymbol = () => {
	return (
		<>
			<div className="difference-symbol">-</div>
		</>
	);
};

export default DifferenceSymbol;
